import { useEffect } from "react";
import { Link, useLoaderData, useNavigate } from "react-router-dom";

import * as API from "../services/who5";
import Who5CardResults from "./Who5CardResults";

import { who5CardData } from "./Who5CardData";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllWho5ByTax(params.tratamientoId);
}

export function Who5ComparativaItem(props) {
  const who5List = useLoaderData();
  const navigate = useNavigate();

  const renderEmptyMessage = () => {
    if (who5List.length === 0) {
      return (
        <h1>
          Aquí podrás ver la evolución de tus resultados. Actualmente no existen
          datos para comparar.
        </h1>
      );
    }
    return null;
  };

  useEffect(() => {
    if (who5List.length === 1 && props.userRole.includes("paciente")) {
      const objectId = who5List[0].id; // Obtén el ID del único objeto
      navigate(`${objectId}`); // Navega a la URL con el ID
    }
  }, [who5List, navigate]);

  // Función para transformar los datos
const transformWho5Data = (who5Data) => {
  // 1. Filtramos sólo los objetos con las cinco preguntas en formato numérico
  //    parseInt() retornará NaN si la cadena no es numérica.
  //    Con isNaN() comprobamos si parseInt devolvió un valor inválido.
  const filteredData = who5Data.filter((who5) => {
    const who5AlegreVal = parseInt(who5.meta?.who5Alegre);
    const who5TranquiloVal = parseInt(who5.meta?.who5Tranquilo);
    const who5ActivoVal = parseInt(who5.meta?.who5Activo);
    const who5DespejadoVal = parseInt(who5.meta?.who5Despejado);
    const who5InteresanVal = parseInt(who5.meta?.who5Interesan);

    return (
      !isNaN(who5AlegreVal) &&
      !isNaN(who5TranquiloVal) &&
      !isNaN(who5ActivoVal) &&
      !isNaN(who5DespejadoVal) &&
      !isNaN(who5InteresanVal)
    );
  });

  // 2. Mapeamos sólo los que pasaron el filtro
  return filteredData
    .map((who5) => {
      const who5AlegreVal = parseInt(who5.meta?.who5Alegre);
      const who5TranquiloVal = parseInt(who5.meta?.who5Tranquilo);
      const who5ActivoVal = parseInt(who5.meta?.who5Activo);
      const who5DespejadoVal = parseInt(who5.meta?.who5Despejado);
      const who5InteresanVal = parseInt(who5.meta?.who5Interesan);

      // Suma total de WHO-5
      const totalSumWho5 =
        4 * (who5AlegreVal + who5TranquiloVal + who5ActivoVal + who5DespejadoVal + who5InteresanVal);

      // Formatear la fecha a dd/mm/aaaa
      const rawFecha = who5.meta?.metaFecha;
      const [year, month, day] = rawFecha.split("-");
      const fecha = `${day}/${month}/${year}`;

      return {
        fecha,
        totalSumWho5
      };
    })
    // Ordena de más antiguo a más reciente
    .sort((a, b) => {
      const dateA = new Date(a.fecha.split("/").reverse().join("-"));
      const dateB = new Date(b.fecha.split("/").reverse().join("-"));
      return dateA - dateB;
    });
};


  // Transformamos los datos de WHO-5
  const transformedWho5List = transformWho5Data(who5List);

  console.log(transformedWho5List);

  return (
    <>
      <div id="content" className="comparativa-graficas-container">
        {renderEmptyMessage() || (
          <form className="analitic-form">
          <h3>{ props.userRole.includes("paciente") ? "Bienestar" : "Cuestionario WHO5" }</h3>
            <div className="three-col-analitic">
              {who5CardData.map((who5Data, index) => (
                <Who5CardResults
                  key={index}
                  title="Puntuación Global"
                  dataKey="totalSumWho5"
                  transformedWho5List={transformedWho5List}
                />
              ))}
            </div>
          </form>
        )}
      </div>
      <div id="actions">
        {!props.userRole.includes("paciente") && (
          <Link className="button is-link" to={`new`}>
            Nuevo
          </Link>
        )}
      </div>
    </>
  );
}
